if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.quantityButton = document.querySelectorAll('.quantity__button')


        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        // Bind all cart-related listeners
        if (!ProductForm.listenersAttached) {
          document.addEventListener('line-item:change', () => {
            console.log(12);
          });
          document.addEventListener('cart:change', () => {
            console.log(890);
          });

          this.bindCartListeners();
          ProductForm.listenersAttached = true;
        }
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onQuantityChange() {
        console.log(123);
        this.bindSubscribeButtonListeners()
      }

      // Updated to scope to cart
      bindPlanSelectListeners() {

        if (!this._planListeners) this._planListeners = new WeakMap();
        const selects = this.cart.querySelectorAll('.plan-select');
        selects.forEach(select => {
          const oldListener = this._planListeners.get(select);
          if (oldListener) {
            select.removeEventListener('change', oldListener);
          }
          const newListener = this.onPlanChange.bind(this);
          this._planListeners.set(select, newListener);
          select.addEventListener('change', newListener);
        });
      }

      // New method to handle button clicks
      bindSubscribeButtonListeners() {
        if (!this._buttonListeners) this._buttonListeners = new WeakMap();
        const buttons = this.cart.querySelectorAll('.subscribe-plan-btn');
        buttons.forEach(button => {
          const old = this._buttonListeners.get(button);
          if (old) button.removeEventListener('click', old);

          const newListener = () => {
            const wrapper = button.closest('.subscription-wrapper');
            const loadingMsg = wrapper.querySelector('.loading-message');

            // 1) Show loading-message and start animating dots
            loadingMsg.style.display = 'block';
            loadingMsg.innerText = 'Loading';
            button.style.display = 'none';
            let dots = 0;
            // save interval so we can clear it later
            wrapper._loadingInterval = setInterval(() => {
              dots = (dots + 1) % 4;
              loadingMsg.innerText = 'Loading' + '.'.repeat(dots);
            }, 500);

            // 2) Trigger the plan‐select change as before
            const select = wrapper.querySelector('.plan-select');
            select.selectedIndex = 1;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          };

          this._buttonListeners.set(button, newListener);
          button.addEventListener('click', newListener);
        });
      }


      // Consolidate listener binding
      bindCartListeners() {
        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          this.bindPlanSelectListeners();
          this.bindSubscribeButtonListeners();
        });

        this.bindPlanSelectListeners();
        this.bindSubscribeButtonListeners();
      }

      onPlanChange(event) {
        const select = event.target;
        const selectedPlanId = select.value;           // “” for one‑time
        const wrapper = select.closest('.subscription-wrapper');
      
        // ─── 1) Figure out which line & what quantity the customer set ───
        const line     = parseInt(wrapper.dataset.line, 10);
        // grab the <input name="updates[]" data-index="…">
        const qtyInput = this.cart.querySelector(
          `input[name="updates[]"][data-index="${line}"]`
        );
        const quantity = qtyInput
          ? parseInt(qtyInput.value, 10)
          : 1;  // fallback to 1 just in case
      
        const button     = wrapper.querySelector('.subscribe-plan-btn');
        const selectorUI = wrapper.querySelector('.subscription-selector');
        const loadingMsg = wrapper.querySelector('.loading-message');
      
        // ─── ONE‑TIME PURCHASE SELECTED ───
        if (selectedPlanId === '') {
          selectorUI.style.display   = 'none';
          loadingMsg.style.display   = 'block';
          loadingMsg.innerText       = 'Loading';
          let dots = 0;
          wrapper._loadingInterval = setInterval(() => {
            dots = (dots + 1) % 4;
            loadingMsg.innerText = 'Loading' + '.'.repeat(dots);
          }, 500);
      
          setTimeout(() => {
            clearInterval(wrapper._loadingInterval);
            delete wrapper._loadingInterval;
            loadingMsg.style.display = 'none';
            button.style.display     = 'block';
          }, 1000);
      
          // ─── pass the actual quantity, not “1” ───
          this.updateCartLine(line, quantity, selectedPlanId);
          return;
        }
      
        // ─── SUBSCRIPTION PLAN SELECTED ───
        this.updateCartLine(line, quantity, selectedPlanId);
      }
      
      

      async updateCartLine(line, quantity, selling_plan) {
        try {
          const res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line, quantity, selling_plan })
          });

          if (!res.ok) throw new Error('Cart change failed');

          const sections = this.cart.getSectionsToRender().map((section) => section.id);
          const sectionsUrl = `${window.location.pathname}?sections=${sections.join(',')}`;
          const htmlRes = await fetch(sectionsUrl);
          const htmlData = await htmlRes.json();

          const parsedState = {
            sections: htmlData,
            id: selling_plan,
          };

          if (this.cart && typeof this.cart.renderContents === 'function') {
            this.cart.renderContents(parsedState);
            // Re-bind all listeners after re-render
            this.bindCartListeners();
          } else {
            console.warn('Cart drawer not ready or renderContents is missing.');
          }
        } catch (error) {
          console.error('Error updating cart line:', error);
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                    this.bindCartListeners();
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
              this.bindCartListeners();
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}